'use client';

import { DATADOG_RUM_NAME, useConsent } from '@lichtblick/consent';
import { useTracker } from '@lichtblick/tracker';
import { type FC, useEffect } from 'react';

interface Props {
  flag: string;
  value: boolean;
}

export const FeatureFlagTracker: FC<Props> = ({ flag, value }) => {
  const datadogRumState = useConsent(DATADOG_RUM_NAME);
  const { trackCustomEvent } = useTracker();

  useEffect(() => {
    if (!datadogRumState) {
      return;
    }

    import('@datadog/browser-rum').then(({ datadogRum }) => {
      datadogRum.onReady(() => {
        datadogRum.addFeatureFlagEvaluation(flag, value);

        datadogRum.setGlobalContextProperty('featureFlags', {
          ...(datadogRum.getGlobalContext().featureFlags as Record<string, boolean>),
          [flag]: value,
        });
      });
    });
  }, [datadogRumState, flag, value]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    trackCustomEvent(
      {
        eventName: 'exp_impression',
        customProps: { exp_name: flag, exp_variant: value ? 'true' : 'false' },
      },
      undefined,
      true,
    );
  }, [flag, value]);

  return null;
};
